module.exports = __webpack_public_path__ + "img/efecty.642a3b1.png";